export { ErrorBoundary, default } from "./routes/contact.tsx";